import React, { Component } from 'react';
import './App.css';
import injectTapEventPlugin from 'react-tap-event-plugin';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import {
  BrowserRouter as Router,
  Route
} from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import Artist from './components/Artist';
import Admin from './components/Admin';
import Login from './components/Login';
import MainView from './components/MainView';
import Utility from './components/Utility';

// Needed for onTouchTap
// http://stackoverflow.com/a/34015469/988941
injectTapEventPlugin();

const muiTheme = getMuiTheme({
  fontFamily: 'Chivo',
  fontWeight: '300'
});

class App extends Component {

  render() {
    return (
      <Router>
        <ScrollToTop>
          <MuiThemeProvider muiTheme={muiTheme}>
            <div className="App">
              <Route exact path="/" component={MainView} />
              <Route path="/artist/:artistid" component={Artist} />
              <Route path="/utility" component={Utility} />
              <Route path="/admin" component={Admin} />
              <Route path="/login" component={Login} />
            </div>
          </MuiThemeProvider>
        </ScrollToTop>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js